import { motion } from "framer-motion";
import { KeyRound } from "lucide-react";

const GastonBeluxy = () => {
  return (
    <section
      className="py-24 md:py-32 relative overflow-hidden"
      style={{
        background:
          "linear-gradient(135deg, hsl(220 69% 4%), hsl(215 48% 12%))",
      }}
    >
      <div className="container px-4 max-w-3xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="rounded-3xl p-8 md:p-12 text-center"
          style={{
            border: "1px solid rgba(201,168,76,0.35)",
            background:
              "linear-gradient(160deg, rgba(255,255,255,0.04), rgba(29,74,140,0.10))",
            boxShadow: "0 30px 80px -40px rgba(201,168,76,0.35)",
          }}
        >
          <div
            className="w-14 h-14 rounded-full flex items-center justify-center mx-auto mb-7"
            style={{
              background: "rgba(201,168,76,0.14)",
              border: "1px solid rgba(201,168,76,0.35)",
            }}
          >
            <KeyRound className="w-6 h-6" style={{ color: "#C9A84C" }} />
          </div>

          <span
            className="text-xs md:text-sm font-semibold tracking-[0.3em] uppercase mb-5 block"
            style={{ color: "#C9A84C" }}
          >
            Una invitación aparte
          </span>

          <h2 className="font-display text-3xl md:text-5xl font-bold text-white leading-[1.1] mb-8">
            Club Beluxy
            <br />
            <span style={{ color: "#C9A84C" }}>La Casa</span>
          </h2>

          <div className="space-y-5 text-base md:text-lg text-white/75 leading-relaxed text-left md:text-center">
            <p>
              Vos lo dijiste: los lugares donde se concentran dueños y directivos
              —cámaras, grupos, Vistage— son donde se empieza a hacer un nombre.
              El Club Beluxy es exactamente eso, curado y sin ruido: un círculo
              privado de líderes de empresas de alto valor, en un contexto donde
              no estás vendiendo — estás construyendo referencia.
            </p>
            <p>
              Como cliente de un programa de Fundación de Autoridad, tenés acceso
              reservado a La Casa en condición preferencial.
            </p>
          </div>

          {/* Acceso */}
          <div
            className="rounded-2xl p-7 mt-10 mb-8"
            style={{
              border: "1px solid rgba(201,168,76,0.25)",
              background: "rgba(0,0,0,0.25)",
            }}
          >
            <p className="text-xs uppercase tracking-[0.25em] text-white/55 mb-3">
              Acceso La Casa
            </p>
            <p
              className="font-display text-4xl md:text-5xl font-bold"
              style={{ color: "#C9A84C" }}
            >
              USD 3.000
            </p>
            <p className="text-sm text-white/50 mt-2 italic">
              Valor de acceso general: USD 3.500
            </p>
          </div>

          <p className="text-sm md:text-base text-white/60 leading-relaxed">
            No forma parte del programa de marca personal: es una puerta que se
            abre por ser parte del círculo. Se suma solo si querés activarla, y
            arranca con la temporada.
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default GastonBeluxy;
